// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status__1JJdH","pending":"styles_pending__3SRoe","approved":"styles_approved__1niVP"};